import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
// import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FIND_DETAIL = function (state, payload) {
  state.row = payload.row
  state.detail = payload.detail
}
mutations.CLEAR_ALL = function (state, payload) {
  state.row = {}
  state.detail = []
}
mutations.TOTAL_SALES = function (state, payload) {
  state.totalsales = payload.total_sales
}
mutations.COUNTRY_LIST = function (state, payload) {
  state.country_list = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  detail: [],
  totalsales: 0,
  country_list: null
}

const actions = {
  init: ({ commit, state }, condition) => {
    const ctx = {
      data: {
        init: { api: 'P0201PurchaseService.doSearch' },
        totalSales: { api: 'P0201PurchaseService.getTotalSales' },
        getCountryListSelectBox: { api: 'C0001CountryService.getCountryListSelectBox' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('FIND_ALL', data.init.output)
        commit('COUNTRY_LIST', data.getCountryListSelectBox.output)
        if (data.totalSales.output) commit('TOTAL_SALES', data.totalSales.output)
      })
  },
  doSearchDetail: ({ commit, state }, condition) => {
    return client.postData({ data: { doSearchDetail: { api: 'P0201PurchaseService.doSearchDetail', input: condition } }
    })
      .then((data) => {
        commit('FIND_DETAIL', data.doSearchDetail.output)
      })
  },
  doFilterDate: ({ commit, state }, condition) => {
    return client.postData({ data: {
      doFilterDate: { api: 'P0201PurchaseService.doSearch', input: condition },
      totalSales: { api: 'P0201PurchaseService.getTotalSales' }
    }
    })
      .then((data) => {
        commit('FIND_ALL', data.doFilterDate.output)
        if (data.totalSales.output) commit('TOTAL_SALES', data.totalSales.output)
      })
  },
  doUpdateTrackingNum: ({ commit, state }, condition) => {
    return client.postData({ data: {
      doUpdateTrackingNum: { api: 'P0201PurchaseService.doUpdateTrackingNum', input: condition }
    }
    })
      .then((data) => {
        commit('FIND_DETAIL', data.doUpdateTrackingNum.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
